import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ClientsService {
  //  private apiUrl = "http://localhost:3003/api/Client";
 private apiUrl = "https://lexipackghana.com:3003/api/Client";
  

  constructor(private http: HttpClient) { }

  //Client
  addClient(data:any){
    return this.http.post(this.apiUrl+'/addClient',data);
  }
  getClientList(){
    return this.http.get(this.apiUrl+'/clientsList');
  }
  getClientById(id: string) {
    return this.http.get(this.apiUrl + '/clients/' + id);
  }
  updateClient(id: string, data: any) {
    return this.http.put(this.apiUrl + '/clients/' + id, data);
  }
  deleteClient(id: string) {
    return this.http.delete(this.apiUrl + '/deleteClientById/' + id);
  }
   // Method to delete multiple clients by IDs
   deleteAllClients(ids: string[]) {
    return this.http.delete<any>(this.apiUrl + '/deleteAllEn', { body: { ids } });
  }
  // Check if a client with the given serverId exists
  // checkClientExists(serverId: string) {
  //   // return this.http.get<boolean>(`${this.apiUrl}/clientExists/${serverId}`);
  //   return this.http.get(this.apiUrl + '/clientExists/' + serverId);

  // }
  // checkContactNoExists(contactNo: string) {
  //   return this.http.post<boolean>(`${this.apiUrl}/check-contact-no`, { contactNo });
  // }

  // checkEmailExists(email: string) {
  //   return this.http.post<boolean>(`${this.apiUrl}/check-email`, { email });
  // }
}
